import { Box, SxProps, Theme } from '@mui/material';
import React from 'react'

type TabPageProps = {
  children?: React.ReactNode;
  dir?: string;
  tab_key: string;
  curr_tab: string;

  style?: React.CSSProperties | undefined;
  sx?: SxProps<Theme>
}

const TabPage = ({ children,
  tab_key, curr_tab,
  style, sx,
  ...props }: TabPageProps) => {
  return (
    <Box
      sx={sx}
      style={style}
      role="TabPage"
      hidden={curr_tab !== tab_key}
      id={`tabpage-${tab_key}`}
      aria-labelledby={`tabpage-${tab_key}`}
      {...props}
    >
      {curr_tab === tab_key && (
        children
      )}
    </Box>
  );
}

export default TabPage